import AuthService from '@/services/AuthService';
import localPermissions from '@/constants/localPermissions';

const userToken = JSON.parse(localStorage.getItem('userToken'))
const currentCollaborator = JSON.parse(localStorage.getItem('currentCollaborator'))
const initialState = userToken && currentCollaborator
  ? { status: { loggedIn: true }, userToken }
  : { status: { loggedIn: false }, userToken: null }

const userDetailLocalStorage = JSON.parse(localStorage.getItem('userDetail'))
const userDetailEmpty = {
  collaboratorList: [],
  email: '',
  technicalId: '',
  networkId: '',
  networkLogo: '',
  hasSeveralCollaborators: false,
  storeList: [],
  permissionList: [],
  phoneNumber: '',
  roleList: [],
  status: ''
}
const userDetail = userDetailLocalStorage ? userDetailLocalStorage : userDetailEmpty

export const auth = {
  namespaced: true,
  state: {
    auth: initialState,
    userDetail: userDetail,
    currentCollaborator: currentCollaborator,
    repairFile: { StoreSelected: null },
    rental: { repairFileBoomerangId: null },
  },
  actions: {
    async login({ commit }, userData) {
      try {
        const userToken = await AuthService.login(userData)
        const connectedUserDetail = await AuthService.me()
        await commit('loginSuccess', userToken)
        await commit('meSuccess', connectedUserDetail)
        return userToken
      } catch (error) {
        commit('loginFailure')
        throw error
      }
    },
    async register({ commit }, userData) {
      return await AuthService.register(userData)
    },
    async me({ commit }) {
      const connectedUserDetail = await AuthService.me()
      await commit('meSuccess', connectedUserDetail)
      localStorage.setItem('userDetail', JSON.stringify(connectedUserDetail))
    },
    async refreshToken({ commit }, accessToken) {
      commit('refreshToken', accessToken)

      const connectedUserDetail = await AuthService.me()
      await commit('meSuccess', connectedUserDetail)
    },
    async logout({ commit }) {
      await AuthService.logout()
      commit('logout')
    },
    async interceptorLogout({ commit }, { router }) {
      await AuthService.logout()
      commit('logout')
      router.push('/login')
    },
    async cleanSession({ commit }) {
      await AuthService.cleanSession()
      commit('sessionCleaned')
    }
  },
  mutations: {
    loginSuccess(state, userToken) {
      state.auth.status.loggedIn = true
      state.auth.userToken = userToken
    },
    meSuccess(state, connectedUserDetail) {
      state.userDetail = connectedUserDetail
      localStorage.setItem('userDetail', JSON.stringify(connectedUserDetail))
    },
    refreshToken(state, accessToken) {
      state.auth.status.loggedIn = true;
      state.auth.userToken = { ...state.auth.userToken, accessToken: accessToken }
    },
    loginFailure(state) {
      state.auth.status.loggedIn = false
      state.auth.userToken = null
      state.userDetail = userDetailEmpty
    },
    logout(state) {
      state.auth.status.loggedIn = false
      state.auth.userToken = null
      state.userDetail = userDetailEmpty
    },
    sessionCleaned(state) {
      state.auth.status.loggedIn = false
      state.auth.userToken = null
      state.userDetail = userDetailEmpty
    },
    updateCollaboratorsList(state, newCollaboratorList) {
      state.userDetail.collaboratorList = newCollaboratorList
    },
    updateOneCollaboratorsInList(state, collaborator) {
      const existsAtIndex = state.userDetail.collaboratorList.findIndex(element => element.technical_id === collaborator.technical_id)
      if (existsAtIndex !== -1) {
        state.userDetail.collaboratorList[existsAtIndex] = collaborator
      }
    },
    selectedCollaborator(state, newCurrentCollaboratorId) {
      const newCurrent = state.userDetail.collaboratorList.find((item => item.technical_id === newCurrentCollaboratorId))
      state.currentCollaborator = newCurrent
      localStorage.setItem('currentCollaborator', JSON.stringify(newCurrent))
    },
    setRepairFileStoreSelected(state, store) {
      state.repairFile.StoreSelected = store;
    },
    setRentalRepairFileBoomerangId(state, repairFileBoomerangId) {
      state.rental.repairFileBoomerangId = repairFileBoomerangId;
    },
    resetRentalRepairFileBoomerangId(state) {
      state.rental.repairFileBoomerangId = null
    }
  },
  getters: {
    hasPermission: (state) => (permissionsRequired) => {
      let hasAccess = false
      for (const permission of permissionsRequired) {
        if (localPermissions[permission]) {
          if (state.userDetail.permissionList.some((perm) => perm.title === localPermissions[permission].title)) {
            hasAccess = true
          }
        }
      }
      return hasAccess
    },
    hasSeveralCollaborators(state) {
      return state.userDetail.hasSeveralCollaborators
    },
    getCurrentCollaborator(state) {
      return state.currentCollaborator
    },
    getCollaboratorListActive(state) {
      return state.userDetail.collaboratorList.filter((user) => user.status === 'active')
    },
    getNetworkLogo(state) {
      return state.userDetail.networkLogo
    },
    getStoreListCollaborator(state) {
      return state.userDetail.storeList
    },
    getRepairFileStoreSelected(state) {
      return state.repairFile.StoreSelected
    },
    getRentalRepairFileBoomerangId(state) {
      return state.rental.repairFileBoomerangId
    }
  }
}
